import { datadogRum } from '@datadog/browser-rum';
import Cookies from 'js-cookie';

import getUserId from './getUserId';

export default function initDataDog() {
  datadogRum.init({
    applicationId: 'f3ec2e8a-067c-4fff-a948-2b7afac52316',
    clientToken: 'pub0c79fb7db38b6693a9d487a4d480ee12',
    site: 'datadoghq.com',
    service: 'core-campaigns-ui',

    env: process.env.CARVANA_APP_ENVIRONMENT,
    version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    beforeSend: ({ view }) => {
      view.url = `${process.env.CVNA_APP_ABSOLUTE_BASE_URL}/racing`;
    }
  });

  datadogRum.setUser({
    id: Cookies.get('BrowserCookieId'),
    userId: getUserId()
  });

  datadogRum.startSessionReplayRecording();
}
